"use client";

import { useTranslations } from "next-intl";

const REASONS = [
	{
		key: "sourceFactory",
		icon: (
			<svg viewBox="0 0 48 48" fill="none" className="h-11 w-11" aria-hidden>
				<rect x="6" y="20" width="36" height="22" rx="2" stroke="currentColor" strokeWidth="1.6" />
				<path
					d="M6 28h36M18 20V6l6 4 6-4v14"
					stroke="currentColor"
					strokeWidth="1.6"
					strokeLinejoin="round"
				/>
				<circle cx="24" cy="34" r="4" stroke="currentColor" strokeWidth="1.4" />
			</svg>
		),
	},
	{
		key: "design",
		icon: (
			<svg viewBox="0 0 48 48" fill="none" className="h-11 w-11" aria-hidden>
				<path
					d="M10 38l4-16L34 8l4 4-14 20-16 4z"
					stroke="currentColor"
					strokeWidth="1.6"
					strokeLinejoin="round"
				/>
				<path d="M28 14l6 6" stroke="currentColor" strokeWidth="1.4" />
				<circle cx="14" cy="34" r="2" fill="currentColor" opacity="0.3" />
			</svg>
		),
	},
	{
		key: "equipment",
		icon: (
			<svg viewBox="0 0 48 48" fill="none" className="h-11 w-11" aria-hidden>
				<circle cx="24" cy="24" r="18" stroke="currentColor" strokeWidth="1.6" />
				<path
					d="M24 14v10l7 4"
					stroke="currentColor"
					strokeWidth="1.8"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path d="M18 6.5A18 18 0 0130 6.5" stroke="currentColor" strokeWidth="1" opacity="0.3" />
			</svg>
		),
	},
	{
		key: "inStock",
		icon: (
			<svg viewBox="0 0 48 48" fill="none" className="h-11 w-11" aria-hidden>
				<rect x="8" y="10" width="32" height="28" rx="2" stroke="currentColor" strokeWidth="1.6" />
				<path d="M8 18h32" stroke="currentColor" strokeWidth="1.4" />
				<path d="M18 26h12M18 32h8" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
			</svg>
		),
	},
	{
		key: "afterSales",
		icon: (
			<svg viewBox="0 0 48 48" fill="none" className="h-11 w-11" aria-hidden>
				<path d="M12 36V20a12 12 0 0124 0v16" stroke="currentColor" strokeWidth="1.6" />
				<rect x="6" y="24" width="6" height="12" rx="2" stroke="currentColor" strokeWidth="1.4" />
				<rect x="36" y="24" width="6" height="12" rx="2" stroke="currentColor" strokeWidth="1.4" />
				<path d="M36 36h2a4 4 0 004-4v-2" stroke="currentColor" strokeWidth="1.2" />
			</svg>
		),
	},
	{
		key: "fullSupport",
		icon: (
			<svg viewBox="0 0 48 48" fill="none" className="h-11 w-11" aria-hidden>
				<path
					d="M24 4l6 12h14l-11 8 4 14-13-9-13 9 4-14L4 16h14l6-12z"
					stroke="currentColor"
					strokeWidth="1.6"
					strokeLinejoin="round"
				/>
			</svg>
		),
	},
];

export default function WhyChooseUs() {
	const t = useTranslations("homeBeauty");

	return (
		<section className="w-full bg-brand-tint py-16 sm:py-20 md:py-24">
			<div className="mx-auto w-full max-w-[1580px] px-5 sm:px-8 lg:px-12">
				<header className="mx-auto max-w-[640px] text-center">
					<span className="text-brand-fg inline-flex items-center gap-2 font-body text-[12px] font-medium uppercase tracking-[0.2em] xl:text-[13px]">
						<span aria-hidden className="inline-block h-px w-8 bg-brand" />
						{t("whyEyebrow") || "Why Us"}
						<span aria-hidden className="inline-block h-px w-8 bg-brand" />
					</span>
					<h2 className="mt-4 font-display text-[clamp(30px,3.25vw,54px)] leading-[1.12] text-brand-ink">
						{t("whyTitle") || "Why Choose Us"}
					</h2>
				</header>

				<div className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-2 md:mt-16 lg:grid-cols-3">
					{REASONS.map((r) => (
						<article
							key={r.key}
							className="group flex gap-5 bg-white p-6 transition-shadow duration-300 hover:shadow-md lg:p-7"
						>
							<div className="text-brand-fg/75 group-hover:text-brand-fg shrink-0 transition-colors duration-300">
								{r.icon}
							</div>
							<div>
								<h3 className="font-display text-[19px] leading-[1.25] text-brand-ink lg:text-[20px] xl:text-[21px]">
									{t(`why_${r.key}_title`) || r.key}
								</h3>
								<p className="mt-2 font-body text-[15px] leading-[1.68] text-brand-muted">
									{t(`why_${r.key}_desc`) || ""}
								</p>
							</div>
						</article>
					))}
				</div>
			</div>
		</section>
	);
}
